import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 .5c3.59 0 6.5 2.909 6.5 6.497v.001A6.496 6.496 0 0 1 7.105 13.5 6.503 6.503 0 0 1 .503 7.216h0L.5 7.004l.003-.189A6.5 6.5 0 0 1 7 .5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.9 6.1h-.7l-.083.004a.7.7 0 0 0 0 1.39l.082.005v2.099l.005.082a.7.7 0 0 0 .613.613l.082.005h.7l.082-.005a.7.7 0 0 0 .613-.613l.005-.082-.005-.082a.7.7 0 0 0-.534-.6l-.079-.014-.082-.004v-2.1l-.005-.081a.7.7 0 0 0-.613-.613zM6.905 4l-.089.005a.7.7 0 0 0 0 1.39l.082.004.09-.004a.7.7 0 0 0 0-1.39z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }